import * as React from 'react';

const IneligibleRegion = () => {
    return (
        <div className="page">
            <div className="form-container pt-4" style={{ minHeight: '40vh' }}>
                <div className="page-header text-center">
                    <h2>Unavailable in your region</h2>

                    <p>
                        As your residential status indicates that you reside in an Excluded Territory, as defined in our{' '}
                        <a target="_blank" rel="noreferrer" href="https://www.chumbacasino.com/terms-and-conditions">
                            Terms & Conditions
                        </a>
                        , we have deactivated your Chumba Casino Customer Account. If you believe you should have
                        access, please{' '}
                        <a target="_blank" rel="noreferrer" href={CONTACT_SUPPORT_CONFIRM_ADDRESS_LINK}>
                            contact us
                        </a>
                        .
                    </p>
                </div>
            </div>
        </div>
    );
};

const CONTACT_SUPPORT_CONFIRM_ADDRESS_LINK =
    'https://chumbacasino.zendesk.com/hc/en-us/requests/new?ticket_form_id=19003678654233';

export default IneligibleRegion;
